import {
  CheckCircleFilled,
  CloudDownloadOutlined, CloudUploadOutlined,
  PlusOutlined,
  SelectOutlined,
  StopFilled
} from "@ant-design/icons";
import { Alert, Breadcrumb, Button, Col, Empty, Image, Input, Popconfirm, Row, Spin, Steps, Table, Upload, notification } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { abmDepDelete, abmDepId, abmDepInfo, abmDepKey, abmDepToken } from "../../axios/api.app";
import { gaEvent } from "../../withTracker";

import { useTranslation } from "react-i18next";

const { Column } = Table;
const { Step } = Steps;
export const EnrollmentIOSABM = () => {
  const routeLocation: any = useLocation();
  const [regisStatus, setRegisStatus] = useState<number>(routeLocation?.state?.regisStatus??0);
  const [abmInfo, setAbmInfo] = useState<any>({});
  const [isUploadFile, setIsUploadFile] = useState<boolean>(false);
  const [step, setStep] = useState<number>(routeLocation?.state?.step??0);
  const [isLoding, setLoding]= useState<boolean>(false);
  const [abmId, setAbmId]= useState<string>("");

  const { t } = useTranslation();

  useEffect(() => {
    getAbmDepInfo(false);
  }, []);


  const onPrevStep = () => {
    setStep(step - 1);
  };

  const onNextStep = () => {
    setStep(step + 1);
  };
  const downKeyClick = () => {
    if (!abmId) {
      abmDepId().then((res) => {
        setAbmId(res.id);
        abmDepKey(res.id).then((res) => {
          let blob = new Blob([res], { type: 'application/x-pem' });
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = "mdmSetting.pem"; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        });
      })
    } else {
      abmDepKey(abmId).then((res) => {
        let blob = new Blob([res], { type: 'application/x-pem' });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "mdmSetting.pem"; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      });
    }

  }
  const getAbmDepInfo = (isFinish: boolean, search: string = "") => {
    abmDepInfo({Organization: search}).then((res) => {
      if (res.length || search) {
        setRegisStatus(1);
        setAbmInfo(res);
      } else {
        setRegisStatus(2);
        if (isFinish) {
          notification.error({ message: t("请完成以上步骤") });
        }
      }
    })
  }
  const beforeUpload = (file: File) => {
    const isPem = file.type === "application/pkcs7-mime";
    if (!isPem) {
      notification.error({ message: t("You can only upload p7m file!") });
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      notification.error({ message: t("Image must smaller than 2MB!") });
    }
    // return isJpgOrPng && isLt2M;
    return true;
  };
  const customRequest = (options: any) => {
    const { onSuccess, onError, file, onProgress } = options;
    try {
      abmDepToken(abmId, { File: file }).then(c => {
        onSuccess();
        setIsUploadFile(true);
        notification.success({ message: t("上传成功") });
      })
    } catch (e) {
      onError();
    }

  };
  const updateAbmInfo = (id: string) => {
    setAbmId(id);
    setRegisStatus(2);
  }
  const addAbmInfo = () => {
    abmDepId().then((res) => {
      setAbmId(res.id);
      setRegisStatus(2);
    })
  }
  const cancelAbmInfo = (id: string) => {
    abmDepDelete(id).then(
      () => {
        notification.success({message: t("取消关联成功")});
        if (abmInfo.length) {
          setRegisStatus(1);
          getAbmDepInfo(false);
        } else {
          setRegisStatus(2);
        }
      },
      () => { notification.error({message: t("取消关联失败")}) }
    )
  }
  const finishClick = () => {
    if (isUploadFile) {
      setAbmId("");
      getAbmDepInfo(true);
    } else {
      notification.error({ message: t("请上传证书文件") });
    }
  }

  const onSearch = (value: string) => {
    getAbmDepInfo(false, value);
    // var tmp = abmInfo instanceof(Array) ? abmInfo : [abmInfo];
    // if (tmp.length && (abmInfo instanceof(Array) ? abmInfo.length : Object.keys(abmInfo).length)) {
    //   tmp = tmp.filter((item) => {
    //     return JSON.stringify({
    //       appleAdminId: item.appleAdminId,
    //       organizationName: item.organizationName,
    //       serverName: item.serverName,
    //       renewedBy: item.renewedBy
    //     }).includes(value);
    //   })
    //   setAbmInfo(tmp);
    // } else {
    //   if (!value) {
    //     getAbmDepInfo(false);
    //   }
    // }
  }

  return (
    <div >
      <div className="breadcrumbTop py-2">
        <Breadcrumb>
          <Breadcrumb.Item>{t("注册")}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("预配置")}</Breadcrumb.Item>
          <Breadcrumb.Item>ABM/ASM</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      
      <Spin spinning={false}>
        <Row style={{ width: "100%" }}>
          {regisStatus === 2 && (
            <div className="borderBox">
              <Alert message={t("提示: 绑定苹果设备前,需要先配置APNs,该配置完成后,未瓴MDM能够自动关联ABM/ASM的设备")} type="warning" showIcon />
              <Steps current={step} className="mt-4">
                <Step title={t("下载 Key")} description="" />
                <Step title={t("下载 token")} description="" />
                <Step title={t("上传 token")} description="" />
              </Steps>
              <Row>
                <Col span={6}></Col>
                <Col span={2} style={{marginTop:"140px",textAlign:"left"}}>
                  {step > 0 && (
                    <a onClick={onPrevStep}>
                      <Image preview={false} width={55} alt="prev" src="/images/prev.png">
                      </Image>
                    </a>
                  )}
                </Col>
                <Col span={8}>
                  <div style={{ height: "500px" }}>
                    {step === 0 && (
                      <div className="text-center py-5">
                        <h4>{t("下载未瓴MDM账号信息的key文件")}</h4>
                        <div className="text-muted mt-3 text-start">
                          {t("下载未瓴MDM账号信息的key文件")},{t("保存到本地")},{t("以便下一步上传到苹果ABM/ASM")}
                        </div>
                        <div>
                          <Button type="primary" size="large" ghost className="w-100 mt-5" onClick={() => { downKeyClick(); gaEvent("enrollmentIosAbm", "onClick", "downKeyClick") }}><CloudDownloadOutlined />{t("下载")}</Button>
                        </div>
                      </div>
                    )}
                    {step === 1 && (
                      <div className="text-center py-5">
                        <h4>
                          {t("下载")} token
                        </h4>
                        <div className="text-muted mt-3 text-start">
                          {t("登录Apple Business/School Manager,点击setting,添加或者修改MDM,上传第一步下载的key并生成token")}
                        </div>

                        <div>
                          <Button className="w-100 mt-5" ghost icon={<SelectOutlined />} type="primary" size="large" target="_blank" href="https://business.apple.com/">
                            {t("打开")} ABM
                          </Button>
                          <Button className="w-100 mt-5" ghost icon={<SelectOutlined />} type="primary" size="large" target="_blank" href="https://school.apple.com/">
                            {t("打开")} ASM
                          </Button>
                        </div>
                      </div>
                    )}
                    {step === 2 && (
                      <div className="text-center py-5">
                        <h4>{t("上传 token")}</h4>
                        <div className="text-muted mt-3 text-start">
                          {t("上传上一步从ABM/ASM下载的token到未瓴MDM")}
                        </div>
                        <Upload
                          accept=".p7m"
                          listType="text"
                          showUploadList={true}
                          //beforeUpload={beforeUpload}
                          customRequest={customRequest}
                          maxCount={1}>
                          <Button className="w-100 mt-5" ghost icon={<CloudUploadOutlined />} type="primary" size="large">{t("点击上传,证书文件以p7m结尾")}</Button>
                        </Upload>
                      </div>
                    )}
                  </div>
                </Col>
                <Col span={2} style={{marginTop:"140px",textAlign:"right"}}>
                  {step < 2 && (
                    <a onClick={onNextStep}>
                      <Image preview={false} width={55} alt="next" src="/images/next.png">
                      </Image>
                    </a>
                  )}
                  {step === 2 && 
                    <a onClick={finishClick}>
                      <Image preview={false} width={55} alt="next" src="/images/next.png">
                      </Image>
                    </a>
                  }
                </Col>
                <Col span={6}></Col>
              </Row>
            </div>
          )}
          {regisStatus === 1 && (
            <>
              <div className="borderBox" style={{ padding: 0 }}>
                <Alert message={<span style={{ fontWeight: 500, fontSize: "1.25rem" }}>ABM/ASM {t("绑定成功")}</span>} type="success" showIcon />
              </div>
              <div className="borderBox">
                <Row style={{ marginBottom: 8 }} justify="space-between">
                  <span style={{ fontSize: "16px", fontWeight: 500, lineHeight: "32px" }}>{t("详情")}</span>
                  <div style={{ display: "flex" }}>
                    <Input.Search placeholder={t("请输入")} allowClear onSearch={onSearch}></Input.Search>
                    <Button type="primary" icon={<PlusOutlined />} style={{ marginLeft: "10px" }} onClick={addAbmInfo}>{t("添加")}</Button>
                  </div>
                </Row>
                <Table
                  size="middle"
                  loading={isLoding}
                  // scroll={{x: 1500}}
                  dataSource={abmInfo instanceof(Array) ? abmInfo : [abmInfo]}
                  // style={{width: "100%"}} 
                  // pagination={false}
                  rowKey={item => item.id}
                  locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty> }}
                >
                  <Column title={t("苹果ID")} key="appleAdminId" dataIndex="appleAdminId"></Column>
                  <Column title={t("组织名称")} key="organizationName" dataIndex="organizationName"></Column>
                  <Column title={t("MDM名称")} key="serverName" dataIndex="serverName"></Column>
                  <Column title={t("有效期")} key="renewedBy" dataIndex="renewedBy"></Column>
                  <Column title={t("状态")} key="validity" dataIndex="validity" 
                    render={(v) => (<>
                      {v && (
                        <span><CheckCircleFilled style={{ color: "#4CB8BE", fontSize: 16 }} />&nbsp;&nbsp;Active</span>
                      )}
                      {!v && (
                        <span><StopFilled style={{ color: "#C9A063", fontSize: 16 }} />&nbsp;&nbsp;Disabled</span>
                      )}
                    </>)}
                  ></Column>
                  <Column title={t("操作")} key="id" dataIndex="id" align="center" ellipsis width={180} render={(id) => {
                    return (
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button type="link" className="updateButton" onClick={() => { updateAbmInfo(id); gaEvent("enrollmentIosAbm", "onClick", "updateAbmInfo") }}>{t("更新")}</Button>
                        <Popconfirm
                            title={`${t("确认取消关联?")}？`}
                            onConfirm={() => { cancelAbmInfo(id); gaEvent("enrollmentIosAbm", "onClick", "cancelAbmInfo") }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Button type="link" block>{t("取消关联")}</Button>
                        </Popconfirm>
                        {/* <Button type="link" className="cancelButton ms-2" onClick={() => { cancelAbmInfo(id); gaEvent("enrollmentIosAbm", "onClick", "cancelAbmInfo") }}>{t("取消关联")}</Button> */}
                      </div>
                    )
                  }}></Column>
                </Table>
                {/* <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Apple ID</th>
                      <td>{abmInfo?.appleAdminId}</td>
                    </tr>
                    <tr>
                      <th>Organzition</th>
                      <td>{abmInfo?.organizationName}</td>
                    </tr>
                    <tr>
                      <th>MDM</th>
                      <td>{abmInfo?.serverName}</td>
                    </tr>
                    <tr>
                      <th>Renewed By</th>
                      <td>{abmInfo?.renewedBy}</td>
                    </tr>
                  </tbody>
                </table>
                <div className="text-center">
                  <Button type="primary" className="updateButton" onClick={() => { updateAbmInfo(); gaEvent("enrollmentIosAbm", "onClick", "updateAbmInfo") }}>{t("更新")}</Button>
                  <Button variant="outlined" danger className="cancelButton ms-2" onClick={() => { cancelAbmInfo(); gaEvent("enrollmentIosAbm", "onClick", "cancelAbmInfo") }}>{t("取消关联")}</Button>
                </div> */}
              </div>
            </>
          )}

        </Row>
      </Spin>
    </div>
  );
};
